import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider, useOutletContext } from "react-router-dom";
import { router, noAuthRouter } from "../routes/router";
import "../assets/styles/style.css";
import Request from "../components/Request";
import { ChakraProvider, useToast } from "@chakra-ui/react";
import theme from "../assets/styles/themes/default";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import LocationVerifier from '../LocationVerifier';

import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

import { UnauthenticatedTemplate, AuthenticatedTemplate } from "@azure/msal-react";

import { msalConfig } from "../config/authConfig";
import ErrorBoundary from "~pages/Errors/ErrorBoundary";
import useCachedMutations from "../mutationsCache/cachedMutations";
import { useState } from "react";

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

//  AJUSTE PARA OS LOGS DE WARNING SEREM TRATADOS COMO WARNING
console.error = function (...args) {
  if (args.length > 0 && typeof args[0] === "string" && args[0].includes("Warning")) {
    console.warn(args[0]);
    return;
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

export const App = () => {
  const [useNoAuth, setUseNoAuth] = useState(false);

  const toast = useToast();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 0,
        networkMode: "always",
        cacheTime: Infinity,
      },
      mutations: {
        mutationFn: () => {
          try {
            const { resumeCachedMutations } = useCachedMutations(toast);
            resumeCachedMutations(queryClient);
          }
          catch (err) {
            console.log("err", err);
          }
        },
      },
    },
  });

  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }} onSuccess={() => {
      queryClient.resumePausedMutations();
    }}>
      <MsalProvider instance={msalInstance}>
        <ChakraProvider theme={theme}>
          <ErrorBoundary>
            <Request setUseNoAuth={setUseNoAuth}>
              <LocationVerifier>
                  <UnauthenticatedTemplate>
                    <RouterProvider router={noAuthRouter} />
                  </UnauthenticatedTemplate>

                  <AuthenticatedTemplate>
                    <RouterProvider router={useNoAuth ? noAuthRouter : router} />
                  </AuthenticatedTemplate>
              </LocationVerifier>
            </Request>
          </ErrorBoundary>
        </ChakraProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </MsalProvider>
    </PersistQueryClientProvider>
  );
};
